import { getRequestUrl, Request } from "../../request";
import { getURL } from "../../utils";

export const get_company_employee = (data) => {
  return Request.get(getURL(`/api/corporation-pa/accounts/set-company-employee/`), data);
};

export const export_company_employee = (data) => {
  return Request.rawGet(getRequestUrl(getURL(`/api/corporation-pa/accounts/set-company-employee/`), data))
}

export const set_company_employee = (data) => {
  return Request.post(getURL(`/api/corporation-pa/accounts/set-company-employee/`), data);
};

export const put_company_employee = (data) => {
  return Request.put(getURL(`/api/corporation-pa/accounts/set-company-employee/`), data);
};

export const set_company_employee_cities = (data) => {
  return Request.post(
    getURL(`/api/corporation-pa/accounts/set-company-employee-cities/`),
    data
  );
};

export const get_company_employee_car = (data) => {
  return Request.get(getURL(`/api/corporation-pa/accounts/set-company-driver-car/`), data);
};
export const set_company_employee_car = (company_driver_id, car_id) => {
  return Request.post(getURL(`/api/corporation-pa/accounts/set-company-driver-car/`), {
    company_driver_id,
    car_id,
  });
};

export const get_provinces = () => {
  return Request.get(getURL(`/api/corporation-pa/locations/provinces/`));
};

export const get_cities = (province_id) => {
  return Request.get(
    getRequestUrl(getURL(`/api/corporation-pa/locations/province-cities/`), { province_id })
  );
};
